const CLIENT_IP_STORAGE_KEY = 'client-public-ip';
const CLIENT_IP_HEADER_NAME = 'ip_address';
const CLIENT_IP_LOOKUP_URLS = [
	'https://api.ipify.org?format=json',
	'https://api64.ipify.org?format=json',
];

let inMemoryClientIp = '';
let clientIpPromise = null;

const readStoredClientIp = () => {
	if (inMemoryClientIp || typeof window === 'undefined') {
		return inMemoryClientIp;
	}

	try {
		const storedClientIp = sessionStorage.getItem(CLIENT_IP_STORAGE_KEY) || '';
		if (storedClientIp) {
			inMemoryClientIp = storedClientIp;
		}
		return storedClientIp;
	} catch (error) {
		return '';
	}
};

const storeClientIp = (clientIp) => {
	if (!clientIp) return;

	inMemoryClientIp = clientIp;

	if (typeof window === 'undefined') return;

	try {
		sessionStorage.setItem(CLIENT_IP_STORAGE_KEY, clientIp);
	} catch (error) {}
};

const fetchClientIpFromUrl = async (url) => {
	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), 3000);

	try {
		const response = await fetch(url, {
			signal: controller.signal,
			headers: {
				Accept: 'application/json',
			},
		});

		if (!response.ok) {
			return '';
		}

		const result = await response.json();
		return typeof result?.ip === 'string' ? result.ip.trim() : '';
	} finally {
		clearTimeout(timeoutId);
	}
};

const resolveClientIpFromUrls = (urls, index = 0) => {
	if (index >= urls.length) {
		return Promise.resolve('');
	}

	return fetchClientIpFromUrl(urls[index])
		.then((clientIp) => {
			if (clientIp) {
				storeClientIp(clientIp);
				return clientIp;
			}

			return resolveClientIpFromUrls(urls, index + 1);
		})
		.catch(() => resolveClientIpFromUrls(urls, index + 1));
};

export const getClientIpAddress = async () => {
	const storedClientIp = readStoredClientIp();
	if (storedClientIp) {
		return storedClientIp;
	}

	if (clientIpPromise) {
		return clientIpPromise;
	}

	clientIpPromise = resolveClientIpFromUrls(CLIENT_IP_LOOKUP_URLS).finally(() => {
		clientIpPromise = null;
	});

	return clientIpPromise;
};

export const withClientIpHeader = async (headers = {}) => {
	const hasClientIpHeader = Object.keys(headers).some(
		(headerName) => headerName.toLowerCase() === CLIENT_IP_HEADER_NAME,
	);

	if (hasClientIpHeader) {
		return headers;
	}

	const clientIpAddress = await getClientIpAddress();
	if (!clientIpAddress) {
		return headers;
	}

	return {
		...headers,
		[CLIENT_IP_HEADER_NAME]: clientIpAddress,
	};
};
